var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTransferToSite = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  focusable: "false",
  viewBox: "0 0 64 64"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 7.53,
  y: 50.5,
  width: 48.94,
  height: 2.22
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m28.63,27.69c.73-.73,1.14-1.14,1.87-1.87v-12.68c-.73-.73-1.14-1.14-1.87-1.87h-12.68c-.73.73-1.14,1.14-1.87,1.87v12.68c.73.73,1.14,1.14,1.87,1.87h12.68Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m35.37,27.69h12.68c.73-.73,1.14-1.14,1.87-1.87v-12.68c-.73-.73-1.14-1.14-1.87-1.87h-12.68c-.73.73-1.14,1.14-1.87,1.87v12.68c.73.73,1.14,1.14,1.87,1.87Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "m24.21,35.88c-.39-.39-1.02-.39-1.41,0s-.39,1.02,0,1.41l9.2,9.2,9.2-9.2c.39-.39.39-1.02,0-1.41s-1.02-.39-1.41,0l-6.79,6.79v-12.4h-2v12.4l-6.79-6.79Z"
})));
export default SvgTransferToSite;